<template>
  <div class="wrap">
    <div class="my_page">
      <div class="key_visual addImg out">
        <div class="container">
          <!-- <p>회원 탈퇴</p> -->
        </div>
      </div>
      <div class="my_page_content cus">
        <div class="container">
          <div class="form_area">
            <form id="withdrawal" @submit.prevent="sendWithdrawalData()">
              <div class="my_page_confirm cus">
                <h3>회원 탈퇴 전 확인해주세요.</h3>
                <p class="text_center withdrawal_starting cus">
                  계정을 삭제하시려는 이유를 알려주세요.<br />
                  라온 메타데미 서비스를 개선하는데 중요한 자료로
                  활용하겠습니다.<br />
                </p>

                <div class="reason_area" style="flex-direction: column">
                  <div class="withdrawal_reason">
                    <input
                      id="MWR01"
                      type="checkbox"
                      value="MWR01"
                      name="cate"
                      @change="handleCheckboxChange"
                    />
                    <label for="MWR01"></label>
                    <label for="MWR01" class="withdrawal_check"
                      >개인 기록 삭제 목적</label
                    >
                  </div>
                  <div class="withdrawal_reason">
                    <input
                      id="MWR02"
                      type="checkbox"
                      value="MWR02"
                      name="cate"
                      @change="handleCheckboxChange"
                    />
                    <label for="MWR02"></label>
                    <label for="MWR02" class="withdrawal_check"
                      >서비스 이용이 불편하고 장애가 많아서</label
                    >
                  </div>
                  <div class="withdrawal_reason">
                    <input
                      id="MWR03"
                      type="checkbox"
                      value="MWR03"
                      name="cate"
                      @change="handleCheckboxChange"
                    />
                    <label for="MWR03"></label>
                    <label for="MWR03" class="withdrawal_check"
                      >마음에 드는 실습 콘텐츠가 없어서</label
                    >
                  </div>
                  <div class="withdrawal_reason">
                    <input
                      id="MWR04"
                      type="checkbox"
                      value="MWR04"
                      name="cate"
                      @change="handleCheckboxChange"
                    />
                    <label for="MWR04"></label>
                    <label for="MWR04" class="withdrawal_check"
                      >삭제하고 싶은 내용이 있어서</label
                    >
                  </div>
                  <div class="withdrawal_reason">
                    <input
                      id="MWR05"
                      type="checkbox"
                      value="MWR05"
                      name="cate"
                      @change="handleCheckboxChange"
                    />
                    <label for="MWR05"></label>
                    <label for="MWR05" class="withdrawal_check"
                      >서비스 사용 빈도가 낮아서</label
                    >
                  </div>
                  <div class="withdrawal_reason">
                    <input
                      id="MWR06"
                      type="checkbox"
                      value="MWR06"
                      name="cate"
                      @change="handleCheckboxChange"
                    />
                    <label for="MWR06"></label>
                    <label for="MWR06" class="withdrawal_check"
                      >다른 사이트가 더 좋아서</label
                    >
                  </div>
                  <div class="withdrawal_reason">
                    <input
                      id="MWR07"
                      type="checkbox"
                      value="MWR07"
                      name="cate"
                      @change="handleCheckboxChange"
                      @click="toggleAdditionalReason"
                    />
                    <label for="MWR07"></label>
                    <label for="MWR07" class="withdrawal_check">기타</label>
                  </div>

                  <div v-if="showAdditionalReason" class="withdrawal_reason">
                    <input id="reason" v-model="additionalReason" type="text" />
                  </div>
                </div>
                <div class="withdrawal_ending cus">
                  <p class="text_center">
                    계정을 삭제하면 회원님의 모든 콘텐츠와 활동 기록 등이
                    삭제됩니다.<br />
                    삭제된 정보는 복구할 수 없으니 신중하게 결정해주세요.<br />
                  </p>
                </div>

                <div class="checkbox">
                  <input id="withdrawal_check" type="checkbox" />
                  <label for="withdrawal_check"></label>
                  <label for="withdrawal_check" class="withdrawal_check"
                    >유의 사항을 모두 확인했으며, 회원을 탈퇴합니다.</label
                  >
                </div>

                <div
                  class="g-recaptcha"
                  :data-sitekey="recaptchasiteKey"
                  @data-callback="onRecaptchaVerified"
                ></div>
              </div>
              <div class="btn_area cus">
                <a href="/mypage" class="btn_basic">취소</a>
                <input type="submit" class="btn_orange" value="탈퇴하기" />
              </div>
            </form>
          </div>
          <div class="Modals">
            <ModalAlert
              :alertMsg="errMsg"
              :isOpen="errStatus"
              :loadingDel="loadDeleteUser"
              @update:isOpen="updateStatus"
            ></ModalAlert>
            <ModalConfirm
              :confirmMsg="errMsg"
              :isOpen="openConfirm"
              :isWithdrawal="withdrawalStatus"
              :loadingDel="loadDeleteUser"
              @update:isOpen="updateConfirmStatus"
              @cancel="closeModal"
              @confirm="doDeleteUser"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
// import { useCookies } from 'vue3-cookies'
import { recaptchaVerifiy, deleteUser } from '../api/withdrawal'
import ModalAlert from '../components/ModalAlert.vue'
import ModalConfirm from '../components/ModalConfirm.vue'
import { loadMypage } from '../api/mypage'

export default {
  name: 'WithdrawalCompleteViews',
  components: {
    ModalAlert,
    ModalConfirm,
  },
  setup() {
    const router = useRouter()
    // const { cookies } = useCookies()

    const errMsg = ref('')
    const errStatus = ref(false)
    const errTrigger = ref('')

    const loadDeleteUser = ref(false)
    const withdrawalStatus = ref(false)
    const openConfirm = ref(false)

    const additionalReason = ref('')
    const showAdditionalReason = ref(false)

    const recaptchasiteKey = process.env.VUE_APP_SITE_KEY // 스테이징
    const recaptTrue = ref(false)

    const scriptUrls = ['https://www.google.com/recaptcha/api.js']

    const updateStatus = () => {
      errStatus.value = false
    }
    const updateConfirmStatus = (status) => {
      openConfirm.value = status
    }
    const loadScripts = async (urls) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const url of urls) {
        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve, reject) => {
          const script = document.createElement('script')
          script.type = 'text/javascript'
          script.src = url
          script.onload = resolve
          script.onerror = reject
          document.head.appendChild(script)
        })
      }
    }

    const toggleAdditionalReason = () => {
      showAdditionalReason.value = !showAdditionalReason.value
    }

    const handleCheckboxChange = (event) => {
      const checkboxes = document.getElementsByName('cate')
      checkboxes.forEach((checkbox) => {
        if (checkbox !== event.target) {
          // eslint-disable-next-line no-param-reassign
          checkbox.checked = false
        }
      })
    }

    const checkRecaptcha = async () => {
      const token = window.grecaptcha.getResponse()
      // console.log(token)
      const recaptchaResult = await recaptchaVerifiy(token)
      // console.log(recaptchaResult)
      if (recaptchaResult === 'EC13000200') {
        recaptTrue.value = true
        return recaptTrue
      }
      recaptTrue.value = false
      return recaptTrue
    }

    const sendWithdrawalData = async () => {
      let frmSt = true
      const checkReasen = document.getElementById('withdrawal_check')
      if (!checkReasen.checked) {
        frmSt = false
        errMsg.value = '회원 탈퇴 안내 사항을 확인하고 동의해주세요.'
        errStatus.value = true
      }
      const checkboxes = document.getElementsByName('cate')
      let checked = false
      let selectedValue = ''
      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          checked = true
          selectedValue = checkbox.value
          if (checkbox.id === 'MWR07') {
            additionalReason.value = document.getElementById('reason').value
          }
        }
      })
      if (!checked) {
        frmSt = false
        errStatus.value = true
        errMsg.value = '회원 탈퇴 사유를 선택해주세요.'
      } else if (selectedValue === 'MWR07' && !additionalReason.value.trim()) {
        frmSt = false
        errStatus.value = true
        errMsg.value = '기타 사유를 입력하여 주세요.'
      }

      const recaptchaVerified = await checkRecaptcha()
      // console.log(recaptchaVerified.value)
      if (!frmSt || !recaptchaVerified.value) {
        errStatus.value = true
        if (!recaptchaVerified.value) {
          errMsg.value = '보안 확인 절차를 진행해주세요.'
        }
        window.grecaptcha.reset()
      } else {
        withdrawalStatus.value = true
        openConfirm.value = true
        errMsg.value =
          '회원 탈퇴를 진행 하시겠습니까?<br>한 번 삭제된 정보는 복구가 불가능합니다.'
      }
    }

    const closeModal = () => {
      window.grecaptcha.reset()
    }

    const doDeleteUser = async () => {
      const checkboxes = document.getElementsByName('cate')
      let selectedCode = ''
      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          selectedCode = checkbox.id
        }
      })
      try {
        console.log(selectedCode)
        console.log(additionalReason.value)
        const result = await deleteUser(selectedCode, additionalReason.value)
        console.log('result ::: ', result)
        if (result === 'MB42000200') {
          console.log('if문 진입')
          // router.push({ path: '/withdrawal_complete_message' })

          // console.log('result ::: ', result)
          // loadDeleteUser.value = true
          // withdrawalStatus.value = true
          // errMsg.value =
          //   '회원 탈퇴가 정상적으로 완료되었습니다.<br>버튼 미 클릭시 1분 후 메인 페이지로 자동 이동됩니다.'
          // errStatus.value = true
          // setTimeout(() => {
          //   router.push({ name: 'IndexViews' })
          // }, 60000)
        } else {
          errMsg.value =
            '탈퇴 처리 중 오류가 발생했습니다. <br> 재로그인 후 다시 시도해주세요'
          errStatus.value = true
        }
      } catch (err) {
        errMsg.value =
          '탈퇴 처리 중 오류가 발생했습니다. <br> 재로그인 후 다시 시도해주세요'
        errStatus.value = true
      }
    }

    // eslint-disable-next-line consistent-return
    const chekcStauts = async () => {
      console.log('init')
      const response = await loadMypage()
      if (response.status_code) {
        if (response.status_code === 200) {
          return 0
        }
      } else if (response === 401) {
        errStatus.value = true
        errTrigger.value = 'onTrigger'
        errMsg.value = '비정상적인 접근입니다.'
      } else {
        console.log('err')
      }
    }

    onMounted(async () => {
      chekcStauts()
      await loadScripts(scriptUrls)
      // console.log(cookies.get('access_token'))
    })

    return {
      errMsg,
      errStatus,
      loadDeleteUser,
      withdrawalStatus,
      openConfirm,

      additionalReason,
      recaptchasiteKey,

      updateStatus,
      updateConfirmStatus,
      closeModal,
      doDeleteUser,

      checkRecaptcha,
      sendWithdrawalData,
      toggleAdditionalReason,
      showAdditionalReason,
      handleCheckboxChange,
      chekcStauts,
    }
  },
}
</script>
